const breakpointNames = ["mobile", "tablet", "desktop", "wide"];
const breakpoints = {
  mobile: 0,
  tablet: 740,
  desktop: 992,
  wide: 1200
};
export {
  breakpointNames,
  breakpoints
};
